import SidePanelContainer from "./SidePanelContainer";
import { useState, useEffect } from "react";
import { faAlignCenter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchInput from "../search/SearchInput";
import TreeNode from "../TreeNode/TreeNode";
import AxiosService from "../../utils/AxiosService";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";

const flattenTree = (node) => {
  let result = [];

  const traverse = (item) => {
    // Skip fake "more" nodes if needed
    if (item.name !== "more") {
      result.push({
        name: item.name,
        doi: item.doi,
      });
    }

    if (item.children && item.children.length > 0) {
      item.children.forEach(traverse);
    }
  };

  traverse(node);
  return result;
};

const toggleNode = (
  node,
  targetName,
  setExpandedNodeId,
  getFunderHierarchy,
) => {
  if (
    node.name === targetName &&
    // !node.onPath &&
    node.children[0]?.id === "more"
  ) {
    getFunderHierarchy(node.id);
  }

  return {
    ...node,
    onPath: node.name === targetName ? !node.onPath : node.onPath,
    children: node.children
      ? node.children.map((child) =>
          toggleNode(child, targetName, setExpandedNodeId, getFunderHierarchy),
        )
      : undefined,
  };
};

const updateSelection = (node, targetName) => {
  return {
    ...node,
    isSearched: node.name === targetName,
    children: node.children
      ? node.children.map((child) => updateSelection(child, targetName))
      : [],
  };
};

const updateHierarchyForChild = (node, childNode, targetId) => {
  return {
    ...node,
    // isSearched: node.id === targetId ? false : node.isSearched,
    // isSearched: false,
    children: node.children.map((child) => {
      if (child.id === targetId) {
        const { isSearched, ...restChildNode } = childNode;
        return {
          ...restChildNode,
          // onPath: child.onPath,
          isSearched: child.isSearched,
        };
      }
      return updateHierarchyForChild(child, childNode, targetId);
    }),
  };
};

function LookupSidePanel({
  hierarchyData,
  setSelectedHierarchyNode,
  setExpandedNodeId,
}) {
  const { get, set, setMultiple } = useCustomSearchParams();
  const [openModule, setOpenModule] = useState(false);
  const [searchedValue, setSearchedValue] = useState("");
  const [treeData, setTreeData] = useState(hierarchyData);
  const [searchedHierarchyNode, setSearchedHierarchyNode] = useState(null);
  const [isFunderHierarchyLoading, setIsFunderHierarchyLoading] =
    useState(false);
  const [funderHierarchyWithChild, setFunderHierarchyWithChild] =
    useState(null);

  const axiosService = new AxiosService();

  // console.log("treeData", treeData);

  function getFunderHierarchy(expandId) {
    const doi = get(SEARCH_PARAMS.DOI);
    const isExpand = true;
    // setMultiple({
    //   [SEARCH_PARAMS.EXPAND_ID]: expandId,
    //   [SEARCH_PARAMS.DOI]: doi,
    // });
    setIsFunderHierarchyLoading(true);
    axiosService
      .getFunderHierarchy({ doi, expandId, isExpand })
      .then((res) => {
        // console.log(
        //   "funder hierarchy =>",
        //   treeData,
        //   res.data,
        //   updateHierarchyForChild(treeData, res.data.tree, expandId),
        // );
        // setFunderHierarchyWithChild(res.data);
        // setTreeData(res.data.tree);
        setTreeData(updateHierarchyForChild(treeData, res.data.tree, expandId));
        // setShowSuggestionDropdown(true);
      })
      .catch((err) => {
        console.error("Error fetching funder hierarchy:", err);
      })
      .finally(() => {
        setIsFunderHierarchyLoading(false);
      });
  }

  function handleClick() {
    setOpenModule(true);
  }

  const handleSearch = (value) => {
    const searchValue = value.trim().length > 0 ? value.trim() : "";

    if (searchValue !== "") {
      const flatData = flattenTree(treeData);
      const searchedHierarchyNode = flatData.filter((item) =>
        item.name.toLowerCase().includes(searchValue.toLowerCase()),
      );

      setSearchedHierarchyNode(searchedHierarchyNode);
    } else {
      setSearchedHierarchyNode(null);
    }

    setSearchedValue(searchValue);
  };

  const handleToggle = (name) => {
    setTreeData((prev) =>
      toggleNode(prev, name, setExpandedNodeId, getFunderHierarchy),
    );
  };

  const handleSelect = (node) => {
    setOpenModule(false);
    setSelectedHierarchyNode(node);
    setTreeData((prev) => updateSelection(prev, node.name));
  };

  return (
    <>
      <button
        className="btn border"
        onClick={handleClick}
        disabled={hierarchyData?.children?.length <= 0}
      >
        <FontAwesomeIcon icon={faAlignCenter} className="text-theme" />{" "}
        <span className="text-muted fw-semibold">
          Filter results by Funder Hierarchy
        </span>
      </button>

      <SidePanelContainer
        title="Funder Hierarchy"
        openModule={openModule}
        setOpenModule={setOpenModule}
        width="500px"
      >
        <div className="mb-4">
          <SearchInput
            placeholder="Search within hierarchy"
            onChange={(value) => handleSearch(value)}
            onSearch={() => {}}
          />
        </div>
        {searchedValue?.length > 0 ? (
          searchedHierarchyNode?.length > 0 ? (
            searchedHierarchyNode.map((item) => (
              <div key={item.doi} className="p-2 border-bottom">
                <button
                  className="btn btn-link text-decoration-none w-100 text-start"
                  onClick={() => handleSelect(item)}
                >
                  {item.name}
                </button>
              </div>
            ))
          ) : (
            <div className="p-2 border-bottom">No Results Found</div>
          )
        ) : (
          <TreeNode
            node={treeData}
            onToggle={handleToggle}
            onSelect={handleSelect}
            isFunderHierarchyLoading={isFunderHierarchyLoading}
          />
        )}
      </SidePanelContainer>
    </>
  );
}

export default LookupSidePanel;
